export default "__VITE_ASSET__BBB9PEeV__"